import React from 'react';
import * as C from "../componentsM/index"

const GlobalContexts = () => {
    return (
        <>

            <C.Hero title={"GLOBAL CONTEXTS"}
                image={"/hero/11.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <p>There are 6 MYP Global Contexts which have been developed from, and extend the PYP transdisciplinary themes:</p>


                    <h1 className='text-myBlue font-bold text-xl md:text-2xl'>Identities and relationships</h1>


                    <p>Students will explore identity; beliefs and values; personal, physical, mental, social and spiritual health; human relationships including families, friends, communities and cultures; what it means to be human.</p>


                    <h1 className='text-myBlue font-bold text-xl md:text-2xl'>Orientation in time and space</h1>


                    <p>Students will explore personal histories; homes and journeys; turning points in humankind; discoveries; explorations and migrations of humankind; the relationships between, and the interconnectedness of, individuals and civilisations, from personal, local and global perspectives.</p>


                    <h1 className='text-myBlue font-bold text-xl md:text-2xl'>Personal and cultural expression</h1>

                    <p>Students will explore the ways in which we discover and express ideas, feelings, nature, ch3ture, beliefs and values; the ways in which we reflect on, extend and enjoy our creativity; our appreciation of the aesthetic.</p>


                    <h1 className='text-myBlue font-bold text-xl md:text-2xl'>Scientific and technical innovation</h1>

                    <p>Students will explore the natural world and its laws; the interaction between people and the natural world; how humans use their understanding of scientific principles; the impact of scientific and technological advances on communities and environments; the impact of environments on human activity; how humans adapt environments to their needs.</p>

                    <h1 className='text-myBlue font-bold text-xl md:text-2xl'>Globalisation and sustainability</h1>

                    <p>Students will explore the interconnectedness of human-made systems and communities; the relationship between local and global processes; how local experiences mediate the global; the opportunities and tensions provided by world-interconnectedness; the impact of decision-making on humankind and the environment.</p>

                    <h1 className='text-myBlue font-bold text-xl md:text-2xl'>Fairness and development</h1>

                    <p>Students will explore rights and responsibilities; the relationship between communities; sharing finite resources with other people and with other living things; access to equal opportunities; peace and conflict resolution.</p>


                </div>
            </section>

        </>

    )
}

export default GlobalContexts